var map = {
	"./baac.svg": 1001,
	"./bay.svg": 1002,
	"./bbl.svg": 1003,
	"./bnp.svg": 1004,
	"./boa.svg": 1005,
	"./cacib.svg": 1006,
	"./cimb.svg": 1007,
	"./citi.svg": 1008,
	"./db.svg": 1009,
	"./ghb.svg": 1010,
	"./gsb.svg": 1011,
	"./hsbc.svg": 1012,
	"./ibank.svg": 1013,
	"./icbc.svg": 1014,
	"./jpm.svg": 1015,
	"./kbank.svg": 1016,
	"./kk.svg": 1017,
	"./ktb.svg": 1018,
	"./lhb.svg": 1019,
	"./mb.svg": 1020,
	"./mega.svg": 1021,
	"./mufg.svg": 1022,
	"./rbs.svg": 1023,
	"./sc.svg": 1024,
	"./scb.svg": 1025,
	"./smbc.svg": 1026,
	"./tbank.svg": 1027,
	"./tcrb.svg": 1028,
	"./tisco.svg": 1029,
	"./tmb.svg": 1030,
	"./ttb.svg": 1031,
	"./uob.svg": 340
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 105;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thaibank ^\.\/.*\.svg$
// module id = 105
// module chunks = 0